import React from "react";
import "./blogDetails.scss";
import image from "../../../assets/blog/successful-medical-team 2.png";
import person from "../../../assets/blog/close-up-young-successful-man-smiling-camera-standing-casual-outfit-against-blue-background 1.png";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsTwitter,
  BsArrowRight,
} from "react-icons/bs";
import SubscribeNews from "../SubscribeNews/SubscribeNews";
import Button from "../../Common/Button/Button";
import Comment from "../Comment/Comment";

const BlogDetails = () => {
  return (
    <section id="blog-deatils-wrapper">
      <div className="blog-deatils">
        <h1>Protect our health from Covid-19 disease</h1>
        <p>
          July 20, 2023 / <span>Covid-19</span>
        </p>
        <img src={image} alt="" />
      </div>
      <div className="row blog-content">
        <div className="col-lg-8 deatils">
          <h2 className="title">Lorem ipsum dolor</h2>
          <p className="description">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo amet set for your cool happiness for lyour
            loyal city. Lorem ipsum dolor sit amet, consectetur adipisicing
            elit, sed do eiusmod tempor incididunt ut labore et dolore magna
            aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
            laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
            dolor in reprehenderit in voluptate velit esse cillum dolore eu
            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deser unt mollit anim id est
            laborum. Sed ut perspiciatis unde omnis iste natus error sit
            voluptatem accusant ium doloremque laudantium, totam rem aperiam,
            eaque ipsa quae ab illo inventore veritatis et quasi architecto
            beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
            voluptas sit asperna tur aut odit aut fugit, sed quia consequuntur
            magni dolores eos quiratione voluptatem sequi nesciunt. Neque porro
            quisquam est. Lorem ipsum dolor sit amet
          </p>
          <h2 className="title">Lorem ipsum dolor</h2>
          <p className="description">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo amet set for your cool happiness for lyour
            loyal city. Lorem ipsum dolor sit amet, consectetur adipisicing
            elit, sed do eiusmod tempor incididunt ut labore et dolore magna
            aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
            laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
            dolor in reprehenderit in voluptate velit esse cillum dolore eu
            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deser unt mollit anim id est
            laborum. Sed ut perspiciatis unde omnis iste natus error sit
            voluptatem accusant ium doloremque laudantium, totam rem aperiam,
            eaque ipsa quae ab illo inventore veritatis et quasi architecto
            beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
            voluptas sit asperna tur aut odit aut fugit, sed quia consequuntur
            magni dolores eos quiratione voluptatem sequi nesciunt. Neque porro
            quisquam est. Lorem ipsum dolor sit amet
          </p>
          <h2 className="title">Lorem ipsum dolor</h2>
          <p className="description">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo amet set for your cool happiness for lyour
            loyal city. Lorem ipsum dolor sit amet, consectetur adipisicing
            elit, sed do eiusmod tempor incididunt ut labore et dolore magna
            aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
            laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
            dolor in reprehenderit in voluptate velit esse cillum dolore eu
            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deser unt mollit anim id est
            laborum. Sed ut perspiciatis unde omnis iste natus error sit
            voluptatem accusant ium doloremque laudantium, totam rem aperiam,
            eaque ipsa quae ab illo inventore veritatis et quasi architecto
            beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
            voluptas sit asperna tur aut odit aut fugit, sed quia consequuntur
            magni dolores eos quiratione voluptatem sequi nesciunt. Neque porro
            quisquam est. Lorem ipsum dolor sit amet
          </p>

          <div className="random-blogs">
            <span> Random Blogs </span>
          </div>
          <div className="row">
            <div className="col-md-3  col-sm-6 random-blogs-image">
              <div className="image-with-overlay">
                <img src={image} alt="" />
                <span>
                  <p>Name</p>
                  <p>lorem ipsum dolor</p>
                </span>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 random-blogs-image">
              <div className="image-with-overlay">
                <img src={image} alt="" />
                <span>
                  <p>Name</p>
                  <p>lorem ipsum dolor</p>
                </span>
              </div>
            </div>
            <div className="col-md-3  col-sm-6 random-blogs-image">
              <div className="image-with-overlay">
                <img src={image} alt="" />
                <span>
                  <p>Name</p>
                  <p>lorem ipsum dolor</p>
                </span>
              </div>
            </div>
            <div className="col-md-3  col-sm-6 random-blogs-image">
              <div className="image-with-overlay">
                <img src={image} alt="" />
                <span>
                  <p>Name</p>
                  <p>lorem ipsum dolor</p>
                </span>
              </div>
            </div>
            <div className="blog-read-more">
              <Button id="arrow-wrapper-right">Read More</Button>
            </div>
            <Comment />
          </div>
        </div>
        <div className="col-lg-4 right-wrapper">
          <div className="personal-details">
            <img src={person} alt="" />
            <h3 className="title">Admin</h3>
            <hr />
            <p className="follow">Follow For More</p>
            <div className="icons">
              <div className="follow-icons">
                <div className="icon">
                  <BsFacebook />
                </div>
                <div className="icon">
                  <BsInstagram />
                </div>
                <div className="icon">
                  <BsLinkedin />
                </div>
                <div className="icon">
                  <BsTwitter />
                </div>
              </div>
            </div>
          </div>
          <div className="popular-post">
            <h3 className="post-heading">Popular Post</h3>
            <hr />
            <div className="row popular-blog">
              <div className="col-4">
                <img src={image} alt="" />
              </div>
              <div className="col-8">
                <div className="catory-date">
                  <p className="category">Covid-19</p>
                  <span>! Day ago</span>
                </div>
                <h3 className="title">
                  Various versions have evolved over the years
                </h3>
                <div className="read-more">
                  <a href="" className="read">
                    Read More
                  </a>
                  <BsArrowRight />
                </div>
              </div>
            </div>
            <div className="row popular-blog">
              <div className="col-4">
                <img src={image} alt="" />
              </div>
              <div className="col-8">
                <div className="catory-date">
                  <p className="category">Covid-19</p>
                  <span>! Day ago</span>
                </div>
                <h3 className="title">
                  Various versions have evolved over the years
                </h3>
                <div className="read-more">
                  <a href="" className="read">
                    Read More
                  </a>
                  <BsArrowRight />
                </div>
              </div>
            </div>
            <div className="row popular-blog">
              <div className="col-4">
                <img src={image} alt="" />
              </div>
              <div className="col-8">
                <div className="catory-date">
                  <p className="category">Covid-19</p>
                  <span>! Day ago</span>
                </div>
                <h3 className="title">
                  Various versions have evolved over the years
                </h3>
                <div className="read-more">
                  <a href="" className="read">
                    Read More
                  </a>
                  <BsArrowRight />
                </div>
              </div>
            </div>
          </div>
          <div className="subscribe">
            <SubscribeNews />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetails;
